import { ClaimV2CornSchema } from '@eigtech/claims-v2-types';
import { JobCornSchema } from '@eigtech/restoration-types';
import { z } from 'zod';
import { InspectionCornSchema } from '../base.js';
import { ImageWithSignedUrlSchema } from '../entities/image.js';
import { LabelFilterSchema } from '../util.js';
export const GetInspectionImagesApiSchema = {
    params: z.object({
        entityId: z.union([ClaimV2CornSchema, JobCornSchema]),
        inspectionId: InspectionCornSchema,
    }),
    query: LabelFilterSchema,
    response: z.object({
        images: ImageWithSignedUrlSchema.array(),
    }),
};
export const GetInspectionImagesRequestSchema = GetInspectionImagesApiSchema.params.merge(GetInspectionImagesApiSchema.query);
